import {
    PROJECTS_USERS_LOADED,
    PROJECTS_ROLES_LOADED,
    PROJECTS_USERS_ROLES_LOADING
} from '../store/actionTypes';

import {Dispatch} from 'redux';
import * as Api from '../../utils/api/api';
import {handleError} from "utils/errorHandle.function";
import {ApplicationError} from 'types/applicationError';
import {ProjectOption, ProjectsAction} from 'types/projects';
import {Role} from 'types/roles';
import {UserDTO} from 'types/userDTO';


export function projectsUsersLoading(value?: ProjectOption[]): ProjectsAction {
    return {
        type: PROJECTS_USERS_ROLES_LOADING,
        data: value
    }
}

export function usersLoaded(value: ProjectOption[]): ProjectsAction {
    return {
        type: PROJECTS_USERS_LOADED,
        data: value
    }
}

export function rolesLoaded(value: ProjectOption[]): ProjectsAction {
    return {
        type: PROJECTS_ROLES_LOADED,
        data: value
    }
}


export function getProjectsUsersAndRoles(companyId: string | number, approvers: number[]) {
    return function (dispatch: Dispatch<ProjectsAction>) {

        dispatch(projectsUsersLoading());

        const asPromises = approvers.map(approver => {
            return Api.getCompanyUser(approver).then((response: UserDTO): ProjectOption => {
                return {value: response.idUser, label: response.fullName};
            });
        });

        Promise.all(asPromises).then(
            values => {
                dispatch(usersLoaded(values))
            }, (error: ApplicationError) => {
                handleError(error);
            });

        Api.getRuleConfigurationRoles(companyId).then((response: Role[]) => {
            let mappedRoles: ProjectOption[] = response ? response.map(role => {
                return {value: role.roleId, label: role.name};

            }) : [];

            dispatch(rolesLoaded(mappedRoles))
        }, (error: ApplicationError) => {
            handleError(error);
        });
    }
}
